/**
 * Courier screen config.
 *
 * Courier details live on the outgoing_invoices row itself - `status` is what
 * separates the two states:
 *   1 -> invoice created, courier still pending
 *   2 -> courier details filled in
 *
 * So the Courier list reads the invoices that already carry courier details and
 * the Courier create screen picks from the ones that do not.
 */

import {
  ZONE_FILTER,
  BRANCH_FILTER,
  STATUS_FILTER,
  OUTGOING_INVOICE_SERIAL_NO_FILTER,
  COURIER_DOCKET_NUMBER_FILTER,
} from "../../custom/Utils/ListFilterOptions";

export const basicFormData = () => ({
  inputData: {
    courier_name: "",
    courier_docket_number: "",
    courier_docket_date: "",
  },
});

// status values on outgoing_invoices
export const COURIER_PENDING = 1;
export const COURIER_COMPLETED = 2;

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "outgoing_invoices",
    schema: schema,
  };

  const navigatePage = { back: "/courier-list" };

  const headerName = "Courier";

  const validationType = "CourierCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getRecords";
  const invoiceViewEndpoint = "/invoice/view";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    invoiceViewEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "outgoing_invoices",
    schema: schema,
    // only invoices whose courier details are already captured
    whereCondition: {
      status: COURIER_COMPLETED,
    },
    include: [
      {
        model: "branch_masters",
        as: "branch",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
    ],
  };

  const navigatePage = {
    create: "/courier-create",
    edit: "/courier-create",
    view: "/courier-view",
  };

  const searchfields = [
    "invoice_number",
    "courier_name",
    "courier_docket_number",
    "zone.zone_name",
    "branch.branch_name",
  ];

  const filterConfig = [
    OUTGOING_INVOICE_SERIAL_NO_FILTER,
    COURIER_DOCKET_NUMBER_FILTER,
    ZONE_FILTER,
    BRANCH_FILTER,
    STATUS_FILTER,
  ];

  const headerName = "Courier";
  const endpoint = "/getRecords";
  const exportFileName = "CourierData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};
